import React, { useState } from 'react';
import { X } from 'lucide-react';

const styles = `
.auth-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.auth-modal {
  background-color: white;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 0.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease;
  position: relative;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.auth-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: #5A9C9C;
  cursor: pointer;
  padding: 0.5rem;
  z-index: 10;
  transition: opacity 0.3s;
}

.auth-close-btn:hover {
  opacity: 0.7;
}

.auth-content {
  padding: 3rem 2rem;
  text-align: center;
}

.auth-title {
  font-size: 2rem;
  color: #5A9C9C;
  margin-bottom: 1rem;
  font-weight: 300;
}

.auth-subtitle {
  color: #6b7280;
  margin-bottom: 2rem;
  font-size: 0.95rem;
}

.auth-subtitle a {
  color: #5A9C9C;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
}

.auth-subtitle a:hover {
  text-decoration: underline;
}

.social-buttons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.social-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.875rem;
  border-radius: 0.375rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 500;
}

.google-btn {
  background-color: white;
  border: 1px solid #d1d5db;
  color: #374151;
}

.google-btn:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}

.facebook-btn {
  background-color: #1877f2;
  border: none;
  color: white;
}

.facebook-btn:hover {
  background-color: #0c63d4;
}

.divider {
  display: flex;
  align-items: center;
  margin: 1.5rem 0;
  color: #9ca3af;
  font-size: 0.875rem;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background-color: #e5e7eb;
}

.divider span {
  padding: 0 1rem;
}

.email-btn {
  width: 100%;
  padding: 0.875rem;
  background-color: white;
  border: 1px solid #5A9C9C;
  color: #5A9C9C;
  border-radius: 0.375rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 500;
}

.email-btn:hover {
  background-color: #f0f9f9;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  text-align: left;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-label {
  color: #5A9C9C;
  font-size: 0.95rem;
  font-weight: 500;
}

.form-input {
  padding: 0.875rem;
  border: none;
  border-bottom: 2px solid #d1d5db;
  font-size: 1rem;
  transition: border-color 0.3s;
  background-color: transparent;
}

.form-input:focus {
  outline: none;
  border-bottom-color: #5A9C9C;
}

.form-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.submit-btn {
  width: 100%;
  padding: 1rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 1rem;
}

.submit-btn:hover:not(:disabled) {
  background-color: #3A6666;
}

.submit-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.checkbox-group {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #6b7280;
  margin-top: 1rem;
}

.checkbox-group input[type="checkbox"] {
  margin-top: 0.25rem;
  width: 18px;
  height: 18px;
  accent-color: #5A9C9C;
  cursor: pointer;
}

.checkbox-group a {
  color: #5A9C9C;
  text-decoration: underline;
  cursor: pointer;
}

.note-text {
  font-size: 0.75rem;
  color: #9ca3af;
  text-align: center;
  margin-top: 1rem;
  line-height: 1.5;
}

.error-message {
  background-color: #fee;
  border: 1px solid #fcc;
  color: #c00;
  padding: 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.success-message {
  background-color: #efe;
  border: 1px solid #cfc;
  color: #060;
  padding: 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

@media (max-width: 640px) {
  .auth-modal {
    width: 95%;
    max-height: 95vh;
  }

  .auth-content {
    padding: 2rem 1.5rem;
  }

  .auth-title {
    font-size: 1.75rem;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}
`;

export default function SignupModal({ isOpen, onClose, onSwitchToLogin }) {
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [showNote, setShowNote] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const [formData, setFormData] = useState({
    nome: '',
    dataNascimento: '',
    cartaoCidadao: '',
    validoAte: '',
    nif: '',
    telefone: '',
    email: '',
    morada: '',
    codigoPostal: '',
    localidade: '',
    outroContacto: '',
    password: '',
    isPublicProfile: true
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    setError('');
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    setSuccess('');
    
    try {
      const response = await fetch('https://www.barcodepapel.pt:5017/api/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      console.log(data)

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao registrar');
      }

      console.log('Registro bem-sucedido:', data);
      
      localStorage.setItem('token', data.token);
      localStorage.setItem('userEmail', data.email);
      localStorage.setItem('userName', data.nome);
      
      setSuccess('Registro realizado com sucesso!');
      
      setTimeout(() => {
        onClose();
        window.location.reload();
      }, 2000);
      
    } catch (error) {
      console.error('Erro:', error);
      setError(error.message || 'Erro ao realizar o registro. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (!showEmailForm) {
    return (
      <>
        <style>{styles}</style>
        <div className="auth-overlay" onClick={onClose}>
          <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
            <button className="auth-close-btn" onClick={onClose}>
              <X size={24} />
            </button>

            <div className="auth-content">
              <h1 className="auth-title">Sign Up</h1>
              <p className="auth-subtitle">
                Already a member? <a onClick={onSwitchToLogin}>Log In</a>
              </p>

              <div className="social-buttons">
                <button className="social-btn google-btn">
                  <svg width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                  Sign up with Google
                </button>

                <button className="social-btn facebook-btn">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  Sign up with Facebook
                </button>
              </div>

              <div className="divider">
                <span>or</span>
              </div>

              <button className="email-btn" onClick={() => setShowEmailForm(true)}>
                Sign up with email
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{styles}</style>
      <div className="auth-overlay" onClick={onClose}>
        <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
          <button className="auth-close-btn" onClick={onClose}>
            <X size={24} />
          </button>

          <div className="auth-content">
            <h1 className="auth-title">Sign Up</h1>
            <p className="auth-subtitle">
              Already a member? <a onClick={onSwitchToLogin}>Log In</a>
            </p>

            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            <div className="auth-form">
              <div className="form-group">
                <label className="form-label">Nome *</label>
                <input
                  type="text"
                  name="nome"
                  className="form-input"
                  value={formData.nome}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Data de Nascimento *</label>
                <input
                  type="date"
                  name="dataNascimento"
                  className="form-input"
                  value={formData.dataNascimento}
                  onChange={handleChange}
                  required
                  max={new Date().toISOString().split('T')[0]}
                  disabled={loading}
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">C. de Cidadão nº *</label>
                  <input
                    type="text"
                    name="cartaoCidadao"
                    className="form-input"
                    value={formData.cartaoCidadao}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Válido até *</label>
                  <input
                    type="date"
                    name="validoAte"
                    className="form-input"
                    value={formData.validoAte}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                </div>
              </div>

                <div className="form-group">
                  <label className="form-label">NIF *</label>
                  <input
                    type="text"
                    name="nif"
                    className="form-input"
                    value={formData.nif}
                    onChange={handleChange}
                    required
                    disabled={loading}
                    maxLength="9"
                  />

              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Telefone *</label>
                  <input
                    type="tel"
                    name="telefone"
                    className="form-input"
                    value={formData.telefone}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Outro contacto</label>
                  <input
                    type="tel"
                    name="outroContacto"
                    className="form-input"
                    value={formData.outroContacto}
                    onChange={handleChange}
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  name="email"
                  className="form-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Morada *</label>
                <input
                  type="text"
                  name="morada"
                  className="form-input"
                  value={formData.morada}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">C. Postal *</label>
                  <input
                    type="text"
                    name="codigoPostal"
                    className="form-input"
                    placeholder="0000-000"
                    value={formData.codigoPostal}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Localidade *</label>
                  <input
                    type="text"
                    name="localidade"
                    className="form-input"
                    value={formData.localidade}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Password *</label>
                <input
                  type="password"
                  name="password"
                  className="form-input"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  minLength="6"
                />
              </div>

              <button 
                type="button"
                className="submit-btn"
                disabled={loading}
                onClick={handleSubmit}
              >
                {loading ? 'Registrando...' : 'Sign Up'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}